import { APP_ENV } from '@/config/env';

/** Socket.IO server origin (no `/api/v1` path). Override with VITE_SOCKET_URL when needed. */
export function getSocketServerUrl(): string {
    const explicit = APP_ENV.VITE_SOCKET_URL?.trim();
    if (explicit) {
        return explicit.replace(/\/$/, '');
    }

    const apiBase = (APP_ENV.VITE_API_BASE_URL || '').trim();
    if (!apiBase) {
        return window.location.origin;
    }

    try {
        return new URL(apiBase).origin;
    } catch {
        return window.location.origin;
    }
}
